import { Box, Paper, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const EmptyDataMessage = ({message}) => {
    return (
       <Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<Paper sx={{ py: 5, px: { xs: 2, md:10}, borderRadius: 4, mt:10, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', display: 'flex', gap:1, alignItems: 'center', }}>
						<SearchIcon sx={{ fontSize: {xs: 30,md:40}, color: 'primary.main' }} />
						<Typography  color={'primary'} sx={{fontSize: { xs: 18, md: 30, fontWeight: 'bold' }}}>{message}</Typography>
					</Paper>
				</Box>
    );
};

export default EmptyDataMessage;